import React from 'react'
import { Breadcrumb, Heading, Divider } from '../common/atoms'
import VerticalProgressBar from '../common/molecules/VerticalProgressBar';
import { email_pre, call_icon, download, info_icon, schedule_call, download_voucher, location as address_icon,
  dob_calendar, doj_calendar, popup_close as closebtn, cancel_btn, dob_icon, employee_name, created_by,
  reschedule_btn, download_rpt_btn, book_apt_btn, approve_apt_rbn, edit_apt } from '../../assets/images';
import moment from 'moment';
import { dsButtonGhostBrand, dsButtonGhostDanger, dsButtonPrimary, dsButtonSecondary, joinButtonClasses } from '../../utils/buttonStyles';

const EmployeeDetailsCard = ({currTab, aptData, onClose, approveRequest, rejectRequest, bookRequest, downloadReport, downloadVoucher, editRequest, rescheduleRequest}) => {

  const bookAptBtn = (row) => {
    return(
      <span className='mx-2'>
        <button
          type='submit'
          onClick={() => bookRequest(row)}
          className={joinButtonClasses(dsButtonPrimary, 'h-11 px-6')}
        >
          <img src={book_apt_btn} height={20} width={20} />
          <span className='ml-1.5 font-semibold'>Book appointment</span>
        </button>
      </span>
    )
  }

  const rejectAptBtn = (row) => {
    return(
      <span className='mx-2'>
        <button
          type='submit'
          onClick={() => rejectRequest(row)}
          className={joinButtonClasses(dsButtonGhostDanger, 'h-11 px-6')}
        >
          <img src={cancel_btn} height={20} width={20} />
          <span className='ml-1.5 font-semibold'>Reject appointment</span>
        </button>
      </span>
    )
  }

  const rejectAptBtnForHR = (row) => {
    return(
      <span>
        <button
          type='submit'
          onClick={() => rejectRequest(row)}
          className={joinButtonClasses(dsButtonGhostDanger, 'h-11 px-6')}
        >
          <img src={cancel_btn} height={20} width={20} />
          <span className='ml-1.5 font-semibold'>Reject Apt.</span>
        </button>
      </span>
    )
  }

  const rescheduleAptBtn = (row) => {
    return(
      <span className='mx-2'>
        <button
          type='submit'
          onClick={() => rescheduleRequest(row)}
          className={joinButtonClasses(dsButtonPrimary, 'h-11 px-6')}
        >
          <img src={reschedule_btn} height={20} width={20}/>
          <span className='ml-1.5 font-semibold'>Reschedule Apt.</span>
        </button>
      </span>
    )
  }

  const downloadVoucherBtn = (row) => {
    return(
      <span className='mx-2'
            style={{ cursor: row.appointment_id ? 'pointer' : 'not-allowed' }}
      >
        <button
          type='submit'
          onClick={() => downloadVoucher(row)}
          className={joinButtonClasses(dsButtonSecondary, 'h-11 px-6', !row.appointment_id && 'pointer-events-none opacity-50')}
        >
          <img src={download_voucher} height={20} width={20}/>
          <span className='ml-1.5 font-semibold'>Download voucher</span>
        </button>
      </span>
    )
  }

  const apporoveAptBtn = (row) => {
    return(
      <span className='mx-2'>
        <button
          type='submit'
          onClick={() => approveRequest(row)}
          className={joinButtonClasses(dsButtonPrimary, 'h-11 px-6')}
        >
          <img src={approve_apt_rbn} height={20} width={20} />
          <span className='ml-1.5 font-semibold'>Approve Apt.</span>
        </button>
      </span>
    )
  }

  const editAptBtn = (row) => {
    return(
      <span className='mx-2'>
        <button
          type='submit'
          onClick={() => editRequest(row)}
          className={joinButtonClasses(dsButtonGhostBrand, 'h-11 px-6')}
        >
          <img src={edit_apt} height={20} width={20} />
          <span className='ml-1.5 font-semibold'>Edit Apt.</span>
        </button>
      </span>
    )
  }

  const downloadRptBtn = (row) => {
    if(row.reports){
      return(
        <span className='mx-2'>
          <button
            disabled={!row.reports}
            type='submit'
            onClick={() => downloadReport(row)}
            style={{ cursor: row.reports ? 'pointer' : 'not-allowed' }}
            className={joinButtonClasses(dsButtonPrimary, 'h-11 px-6')}
          >
            <img src={download_rpt_btn} height={20} width={20}/>
            <span className='ml-1.5 font-semibold'>Download Report</span>
          </button>
        </span>
      )
    }else return
  }

  const returnTabBtn = (tab_header, row) => {
    switch(tab_header){
      case 'ready_to_book':
        return readToBookBtn(row);
      case 'contacted':
        return contactedBtn(row);
      case 'not_reachable':
        return notReachableBtn(row);
      case 'scheduled':
        return scheduledBtn(row);
      case 'rescheduled':
        return rescheduledBtn(row);
      case 'hr_intervention':
        return hrInterventionBtn(row);
      case 'awaiting_reports':
        return awaitingReportsBtn(row);
      case 'completed':
        return completedBtn(row);
      case 'rejected':
        return rejectedBtn(row);
    }
  }

  const readToBookBtn = (data) => {
    return(
      <div className='flex flex-row'>
        {rejectAptBtn(data)}
        {bookAptBtn(data)}
      </div>
    )  
  }

  const contactedBtn = (data) => {
    return(
      <div className='flex flex-row'>
        {bookAptBtn(data)}
      </div>
    )  
  }

  const notReachableBtn = (data) => {
    return(
      <div className='flex flex-row'>
        {bookAptBtn(data)}
      </div>
    )  
  }

  const scheduledBtn = (data) => {
    return(
      <div className='flex flex-row'>
        {downloadVoucherBtn(data)}
        {rescheduleAptBtn(data)}
      </div>
    )  
  }

  const rescheduledBtn = (data) => {
    return(
      <div className='flex flex-row'>
        {downloadVoucherBtn(data)}
        {rescheduleAptBtn(data)}
      </div>
    )  
  }

  const hrInterventionBtn = (data) => {
    let noResponse = data.status == 'rejected' ? true : false
    return(
      <div className='flex flex-row'>
        {rejectAptBtnForHR(data)}
        {/* {editAptBtn(data)} */}
        { noResponse && apporoveAptBtn(data)}
        { !noResponse && bookAptBtn(data)}
      </div>
    )  
  }

  const awaitingReportsBtn = (data) => {
    return(
      <div className='flex flex-row'>
        {downloadVoucherBtn(data)}
      </div>
    )  
  }

  const completedBtn = (data) => {
    return(
      <div className='flex flex-row'>
        {downloadRptBtn(data)}
      </div>
    )  
  }

  const rejectedBtn = (data) => {
    return(
      <div className='flex flex-row'>
        {rescheduleAptBtn(data)}
      </div>
    )  
  }

  const employeeDetails = (data) => {
    return(
      <div className='mt-2 bg-white p-6 w-full h-2/5 mr-3 border rounded' style={{borderColor: '#E5E8F0'}}>
        <div className='text-sm leading-3 font-semibold tracking-wider' style={{color: '#475569'}}>EMPLOYEE DETAILS</div>
          <Divider classes='w-full mt-4'/>
          <div className='flex flex-row'>
            <div className='mt-4 w-1/2'>
              {renderSet("NAME", data?.name, employee_name)}
              {renderSet("PHONE NUMBER", data?.mobile_number, call_icon)}
              {renderSet("EMAIL ID", data?.email, email_pre)}
            </div>
            <div className='mt-4 w-1/2'>
              {renderSet("DOB", data?.date_of_birth, dob_icon)}
              {renderSet("DATE OF JOINING", data?.date_of_joining, doj_calendar)}
              {renderSet("ADDRESS", data?.address, address_icon)}
            </div>
          </div>          
      </div>
    )
  }

  const appointmentDetails = (data) => {
    return(
      <div className='mt-2 bg-white p-6 w-full h-1/3 mr-3 border rounded' style={{borderColor: '#E5E8F0'}}>
      <div className='text-sm leading-3 font-semibold tracking-wider' style={{color: '#475569'}}>APPOINTMENT DETAILS</div>
      <Divider classes='w-full mt-4'/>
      <div className='flex flex-row'>
        <div className='mt-4 w-1/2'>
          {renderSet("APPOINTMENT DATE", data?.appointment_date, dob_calendar)}
          {renderSet("CREATOR EMAIL ID", data?.created_by?.email, email_pre)}
        </div>
        <div className='mt-4 w-1/2'>
          {renderSet("CREATED BY", data?.created_by?.name, created_by)}
        </div>
      </div>
      </div>
    )
  }

  const appointmentTimeline = (data) => {
    let apptRequestTimelines = data?.appointment_request_timelines
    let apptTimelines = [...apptRequestTimelines]
    apptTimelines = apptTimelines.sort((a,b) => moment(b.created_at, "DD MMM YYYY | HH:mm A") - moment(a.created_at, "DD MMM YYYY | HH:mm A"))
    let apptTimelinesKeys = Object.keys(apptTimelines)
    if(apptTimelinesKeys.length !== 0){
      return(
        apptTimelinesKeys.map((key, index) => {
          if(apptTimelines[key]?.apt_status?.status === 'Awaiting reports') return

          let backgroundColor = apptTimelines[key]?.apt_status?.background_color
          let textColor = apptTimelines[key]?.apt_status?.status === 'HR Intervention' ? 'text-black' : 'text-white'
          return(
            <li>
              <div className='relative w-96 pb-8' style={{left: '52px'}}>
                <div className='text-xs mb-2 font-semibold uppercase tracking-wide' style={{color: '#9CA3AF'}}>{apptTimelines[key]?.created_at}</div>
                <div className='mb-3'>
                  <span className={`text-base font-semibold rounded-3xl px-4 py-2 ${textColor}`} style={{backgroundColor: backgroundColor}}>
                    {apptTimelines[key]?.apt_status?.status}
                  </span>
                </div>
                {/* <div className='text-sm font-normal mb-2'>Status changed Contacted to Scheduled</div> */}
                { apptTimelines[key]?.comments && <div className='font-normal text-sm leading-3'>Comment: <span className='font-semibold ' >{apptTimelines[key]?.comments}</span></div>}
              </div>
            </li>
          )
        })
      )
    }else{
      return(
        <div className='flex h-full justify-center m-12 text-center items-center font-semibold text-xs leading-4 tracking-wide' style={{color: '#9CA3AF'}}>
          NO DATA AVAILABLE
        </div>
      )
    }
  }

  const contactFrequency = (data) => {
    return(
      <div className='mt-2 p-6 w-full h-48' style={{borderColor: '#E5E8F0'}}>
        <div className='text-sm leading-3 font-semibold tracking-wider' style={{color: '#475569'}}>CONTACT FREQUENCY: {data?.contacted_frequency} TIMES</div>
        <Divider classes='w-full mt-4'/>
        <div>
          {renderContactedFreq(data?.contacted_on)}
          { data?.contacted_frequency === 0 && <div className='m-12 text-center font-semibold text-xs leading-4 tracking-wide' style={{color: '#9CA3AF'}}>NO DATA AVAILABLE</div>}
        </div>
      </div>
    )
  }

  const renderContactedFreq = (data) => {
    if(data){
      return(
        data.map((val, index) => {
          if(index == 0){
            return(
              <div  className='flex flex-row'>
              {renderSet('LAST CONTACTED ON', val, schedule_call)}
            </div>
            )
          }else{
            return(
              <div  className='flex flex-row'>
              {renderSet('CONTACTED ON', val, schedule_call)}
            </div>
            )
          }
        }))}      
    }

  const renderSet = (title, desc, img, imgSize = '24px') => {
    return(
          <div className='leading-3 text-xs flex flex-row m-6 overflow-hidden'>
            <span className='mx-2 mt-0.5'>
              <img src={img} alt='email' style={{width: imgSize}} />
            </span>
            <span>
              <div className='text-gray-400 mb-1.5 font-medium tracking-wider'>{title}</div>
              <div className='text-sm leading-3.5 font-bold' style={{color: '#4B5563'}}>{desc ? desc : 'NA'}</div>
            </span>
          </div>
      )
    }

  return (
      <div className='p-8 bg-gray-100 min-h-screen -m-6 relative'>
        <img src={closebtn} alt='close-btn' className='absolute right-8 top-4 cursor-pointer h-8 w-8' onClick={onClose} />
        <div className='text-xs text-gray-400 mt-0 mb-2'>
          <span onClick={onClose} className='cursor-pointer hover:text-gray-600'>Pre-Policy Medical Checkup</span>
          <span className='font-semibold cursor-pointer hover:text-gray-600' > /  View Details</span>
        </div>
        <div className=''>
          <div className=''>
            <Heading mainHeading={'Employee details'} mainClasses='font-fig-extrabold text-2xl font-medium leading-tight tracking-tight text-gray-900 sm:text-3xl' />
          </div>
          <div className='mx-6 flex justify-end'>
            {returnTabBtn(currTab, aptData)}
          </div>
        </div>
        
        <Divider classes='w-full' />
        <div className='flex flex-row'>
          <div className='w-1/2 mr-3'>
            <div className='mb-4 mt-8'>
              {employeeDetails(aptData)}
            </div>
            <div className='mb-6'>
              {appointmentDetails(aptData)}
            </div>
            <div className='overflow-auto bg-white border rounded'>
              {contactFrequency(aptData)}
            </div>
          </div>
          <div className='w-1/2 mt-8 ml-3 overflow-auto bg-white border rounded'>
          <div style={{ minHeight: '780px', overflowY: 'scroll', '&::WebkitScrollbar': { width: '3px'}, '&::WebkitScrollbarThumb': { height: '50px', background: '#9CA3AF', borderRadius: '40px'}, '&::WebkitScrollbarTrack': { borderRadius: '40px'}}}>
            <VerticalProgressBar
              mainclasses='w-full p-6 h-96'
              titleclass='text-sm leading-3 ml-1 font-semibold tracking-wider'
              title='APPOINTMENT DETAILS'
              child={appointmentTimeline(aptData)}
            />
        </div>
          </div>
        </div>
      </div>
    )
}

export default EmployeeDetailsCard
